import { redirect, type RouteObject } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'

import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const peopleRoutes: RouteObject = {
  path: 'people',
  async lazy() {
    const { PeopleRoute, PeopleRouteBreadCrumb } = await import(
      '../client/components/Admin/People/PeopleRoute.js'
    )

    return {
      element: <PeopleRoute />,
      handle: routeCrumb(PeopleRouteBreadCrumb),
    }
  },
  children: [
    {
      index: true,
      loader: () => redirect('members'),
    },
    {
      async lazy() {
        const { RouteContainer } = await import(
          '../client/components/Container/RouteContainer.js'
        )

        return { Component: RouteContainer }
      },
      children: [
        {
          path: 'members',
          async lazy() {
            const { Members, MembersCrumb } = await import(
              '../client/components/Admin/Members/index.js'
            )

            return {
              Component: Members,
              handle: routeCrumb(MembersCrumb),
            }
          },
        },
        {
          path: 'invitations',
          async lazy() {
            const { Invitations, InvitationsCrumb } = await import(
              '../client/components/Admin/Members/Invitations.js'
            )

            return {
              Component: Invitations,
              handle: routeCrumb(InvitationsCrumb),
            }
          },
        },
        {
          path: 'admin',
          loader: () => redirect(adminRoutes.people.staff),
        },
        {
          path: 'staff',
          async lazy() {
            const { Staff, StaffCrumb } = await import(
              '../client/components/Admin/Members/Staff.js'
            )

            return {
              Component: Staff,
              handle: routeCrumb(StaffCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'fields',
      async lazy() {
        const { MemberFields, MemberFieldsCrumb } = await import(
          '../client/components/Admin/MemberFields/index.js'
        )

        return {
          Component: MemberFields,
          handle: routeCrumb(MemberFieldsCrumb),
        }
      },
    },
    {
      path: 'badges',
      async lazy() {
        const { MemberBadges, MemberBadgesCrumb } = await import(
          '../client/components/Admin/MemberBadges/index.js'
        )

        return {
          Component: MemberBadges,
          handle: routeCrumb(MemberBadgesCrumb),
        }
      },
    },
  ],
}
